
import { Component, Prop, Vue } from "vue-property-decorator";
import { TreeStructure } from "@gsx/common";

@Component
export default class CountryTreeGroup extends Vue {
    @Prop() children!: TreeStructure[];
    @Prop({ default: false }) open!: boolean;
    @Prop() filterStore!: any;
}
